export default __webpack_public_path__ + "static/media/eliminar.4b7c48aa.png";